export const STAMMDATEN_PAGE_SIZE = 50;
export const STAMMDATEN_MODEL_SUFFIX = "_StammdatenBasis_S_D";

export namespace Paths {
	export const IS_AUTOMATICALLY_CREATED = "/root/stammdatenDefault/stammdatenMetadata/isAutomaticallyCreated";
	export const IS_EDITING_ALLOWED = "/root/stammdatenDefault/stammdatenMetadata/isEditingAllowed";
}
